import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ConfirmContext from "../utils/confirmContext";
import { useContext } from "react";
import { slugCombine } from "../utils/slugManager";
import config from "../configuration/config";


function Slide({
    id,
    modelTypes,
    img,
    bg,
    type,
    seats,
    name,
    brand,
    year,
    slug,
    minPrice,
    HP,
    cylinders,
    petrol,
    colorID,
    RateCareDiscount,
    group,
    Tax,
    ProductId,
    otherBrand,
    end_Offer,
    NewCar_DateEnd,
    NewCar,
    Hybird,
    showPric,
    hybridImage,
    viewSliderIcon,
    viewSliderDetails,
    viewBtns,
    sliderBackOpasity,
    brandID,
}) {

    const { t: trans, i18n } = useTranslation(["car", "common", "vehicales", "info"]);
    const lang = i18n.language || 'ar';

    const context = useContext(ConfirmContext);

    function handleRequest() {
        try {
            context.onShow(
                {
                    displayConfirm: true,
                    title: name,
                    image: img,
                    brand: brand,
                    isHyper: Hybird,
                    isNew: NewCar,
                    type: type,
                    brandID: brandID,
                    defaultColorID: colorID,
                    modelYear: year,
                    cartDetails: {
                        id: ProductId,
                        name: name,
                        price: minPrice,
                        brand: brand,
                        image: img,
                        Tax: Tax,
                        Discount: RateCareDiscount,
                        Type: "car",
                        modelTypes: modelTypes
                    },
                    carOrder: {
                        vehicle: ProductId,
                        group: group
                    },
                }
            );
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <section className="hero">
            <div className="ctn ltr-fixed"> {/* Force LTR layout for consistent car/specs positioning */}
                <div className="hero-left">
                    <div className="hero-tag">
                        <span className="dot"></span>
                        {brand}
                    </div>
                    <h1>
                        {name}
                    </h1>
                    <p className="hero-sub">
                        {lang === 'ar'
                            ? 'احجز السيارة المختارة بسهولة. انضم لخدماتنا واستكشف التميز والرفاهية مع أحدث الموديلات.'
                            : 'Book your selected car easily. Join our services and explore excellence and luxury with the latest models.'}
                    </p>

                    <div className="hero-btns">
                        <Link to={`/vehicles/${slugCombine(brand, otherBrand)}/${group}/${year}`} className="hero-btn dark">
                            <svg viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3" /></svg>
                            {trans("car:overview")}
                        </Link>
                        <button onClick={handleRequest} className="hero-btn primary">
                            {trans("common:buy")} {year}
                        </button>
                    </div>
                </div>

                <div className="hero-right">
                    <div className="hero-bg-accent"></div>
                    <div className="hero-car">
                        <Link to={`/vehicles/${slugCombine(brand, otherBrand)}/${group}/${year}`} className="hero-car-link">
                            <img
                                src={config.FilePathURL + img}
                                onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = bg ? config.FilePathURL + bg : "https://appw.hassanjameelapp.com/assets/UrlImages/E04E7C28-5B13-411F-9080-BA480B265727E-Hybrid-%D9%81%D8%B6%D9%8A-%D9%85%D8%B9%D8%AF%D9%86%D9%8A.webp";
                                }}
                                alt={name}
                            />
                        </Link>
                        {/* <div className="hero-car-label">{name} {year}</div> */}
                    </div>

                    {viewSliderDetails && (
                        <div className="hero-specs-bar">
                            {(HP || HP === "0") && (
                                <div className="hs-item">
                                    <div className="hs-val">{HP}</div>
                                    <div className="hs-lbl">{trans("car:horse")}</div>
                                </div>
                            )}
                            {(cylinders || cylinders === "0") && (
                                <div className="hs-item">
                                    <div className="hs-val">{cylinders}</div>
                                    <div className="hs-lbl">{trans("car:cylinders")}</div>
                                </div>
                            )}
                            {(seats || seats === "0") && (
                                <div className="hs-item">
                                    <div className="hs-val">{seats}</div>
                                    <div className="hs-lbl">{trans("car:seats")}</div>
                                </div>
                            )}
                            {petrol && (
                                <div className="hs-item">
                                    <div className="hs-val">{petrol}</div>
                                    <div className="hs-lbl">{trans("car:petrol")}</div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default Slide;